module.exports = __webpack_public_path__ + "340711b5b1e4916fb35afb8403c366b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/action-center-employees/icon4.jpg
// module id = 1605
// module chunks = 0